import React, { useEffect, useRef, useState } from 'react';
import './Home.scss';
import classNames from 'classnames';
import { Row, Col, Button, Input, Typography, Card, Avatar, Space, Image, Table,Tooltip, Dropdown,message, Divider, theme, Carousel, Flex, Slider, Switch, Tabs, Select } from "antd";
import { ServiceUtils } from '../../Shared/Utils/ServiceUtils';
import { alertService } from '../../Shared/Utils/ToasterUtils';
import { useNavigate } from 'react-router-dom';
import ConferenceImage from '../../Assets/images/conference.png';
import { getDecryptSession } from '../../Shared/Utils/CommonUtils';
import {
  DeleteOutlined, EditOutlined, MoreOutlined,FileTextOutlined,ArrowRightOutlined
} from '@ant-design/icons';
import KOL from './KOL.js/KOL';
import ArcutisAttendee from './ArcutisAttendee/ArcutisAttendee';
import { useSharedState } from "../../Shared/Services/WindowSizeService";
import Survey from './Survey/Survey';
import useWindowSize from '../../Shared/Utils/windowResizeUtils';
import surveyImage from "../../Assets/images/Survey.svg";
import moreImage from "../../Assets/images/3 dots.svg";
import { useAppContext } from '../../Shared/Utils/AppContext';
import ReactEcharts from 'echarts-for-react';
import EmbedReports from './EmbedReports/EmbedReports';
import Reports from './Reports/Reports';

export default function Home({ ...props }) {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width <= 768;
  const deviceWidth = width <= 430;
  // const cardStyle = deviceWidth ? {} : { display: 'flex', justifyContent: "center", alignItems: 'center', marginBottom: '5px' } ;
  const cardStyle = { 
    display: 'flex', 
    margin: '5px'
    // justifyContent: "center", 
    // alignItems: 'center', 
    // marginBottom: '5px' 
  };
  const { Title, Text } = Typography;
  const Search = Input.Search;
  const windowSize$ = useSharedState();
  const [tabList, settabList] = useState([]);
  const [dataObj, setDataObj] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const [attendeeList, setAttendeeList] = useState([]);
  const [selectedMenu, setMenu] = useState(localStorage.getItem("activetab") ? JSON.parse(localStorage.getItem("activetab")) : { label: "Conferences", key: 'Conference' });
  const [searchQuery, setSearchQuery] = useState('');
  const [userDetails, setUserDetails] = useState({});
  const [activeSurveyList,setActiveSurveyList] = useState([]);
  const { data, updateData } = useAppContext();
  const [currentReportIndex, setCurrentReportIndex] = useState();
  const [expanded, setExpanded] = useState(false);
  const [switchStates, setSwitchStates] = useState({
    current_year: true,
    all_conference: false,
  });
  const [embeddedReports, setEmbeddedReports] = useState({});
  const [workspace, setWorkspaceOptions] = useState();
  const effectHasRun = useRef(); 
  effectHasRun.current = false
  const switchData = [
    { key: 'current_year', label: 'Current Year' },
    { key: 'all_conference', label: 'All Conference' },
  ];

  useEffect(()=>{
    const session = localStorage.getItem("arcutis-user");
    const userDetails = getDecryptSession(session);
    let homePage = false;

    listOfWorkspaceOptions();

     Object?.keys(userDetails?.role_access?.home)?.map((key)=>{
      if(userDetails?.role_access?.home[key]?.edit || userDetails?.role_access?.home[key]?.view){
        homePage = true
      }
    })
    let tabs = [
      {
        label: "Conferences",
        key: "Conference",
        view: homePage,
      },
      {
        label: "Arcutis Attendee",
        key: "Attendee",
        view: userDetails?.role_access?.arcutisAttendee?.view,
      },
      {
        label: "KOL Profiles",
        key: "KOL",
        view: userDetails?.role_access?.kolProfiles?.view,
      },
      {
        label: "Reports",
        key: "Reports",
        view: userDetails?.role_access?.reports?.view,
      }
      // {
      //   label: "Medicaid",
      //   key: "Medicaid",
      //   view: userDetails?.role_access?.reports?.view,
      // }
    ];
    let accessibleTabs = tabs?.filter((tab)=>{
      return(tab?.view)
    })
    const medicaid = [
      {
        label: "Medicaid",
        key: "Medicaid",
        // view: userDetails?.role_access?.reports?.view,
      }
    ]
    settabList([...accessibleTabs,...medicaid])
    onTabSelect({key:accessibleTabs?.[0]?.key})
  },[])


   const listOfWorkspaceOptions = () => {
       const payload = {
        type: 'reports'
       }
        ServiceUtils.postRequest("listWorkspaces",payload).then(
          (response) => {
            if (response?.data.status) {
              setWorkspaceOptions(response?.data?.data);
            } else if (response.status === 401) {
              navigate("/logout");
            } else {
              alertService.error(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      };
      
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

useEffect(()=>{
  if(data?.key?.length > 0){
    onTabSelect(data)
  }
},[data])

const filteredAttendeeList = attendeeList.filter((attendee) =>
    Object.values(attendee).some(
      (value) =>
        typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const filteredProfileList = profileList.filter((profile) =>
    Object.values(profile).some(
      (value) =>
        typeof value === 'string' && value.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  useEffect(() => {
    const history = localStorage.getItem('history');
    if (history && history !== '/home') {
      navigate(history);
      return;
    }
    const currentTab = JSON.parse(localStorage.getItem("activetab"));
    if (currentTab) {
      let activeTa = currentTab.key;
      selectedMenu.key = activeTa;
      setMenu(selectedMenu);
      if (currentTab.key === 'Conference') {
        fetchMeetingList();
        getActiveSurveys();
      } else if (currentTab.key === 'Profile') {
        // fetchProfileList();
      } else if (currentTab.key === 'Reports'){
        // getAttendee();
      }
       else {
        // fetchAttendeeList();
      }
    }
    else {
      fetchMeetingList();
      getActiveSurveys();
    }
    const session = localStorage.getItem("arcutis-user");
    const userDetails = getDecryptSession(session);
    setUserDetails(userDetails);
    let hasConfernce = JSON.parse(localStorage.getItem('hasConfernce'));
    if(hasConfernce) {
      fetchMeetingList();
    }
  }, [switchStates])




  const fetchMeetingList = () => {
    const getSessionData = localStorage.getItem("arcutis-user");
    const session = getDecryptSession(getSessionData);
    if(!session?.role_access?.home?.conferences?.view) return;
    let payload = switchStates;
    ServiceUtils.postRequest('listOfConferences',payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          setDataObj(response.data.data)
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        alertService.error('Error while fetching data')
        console.log(error)
      }
    );
  };
 

  const fetchProfileList = () => {
    let payload = {}
    ServiceUtils.postRequest('listOfProfiles', payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          setProfileList(response.data.data)
        } 
        else if(response.status === 401 ){
          navigate('/logout');
        }
        else {
          alertService.error(response.data.message)
        }
      },
      (error) => {
        alertService.error('Error while fetching data')
        console.log(error)
      }
    );
  };




  const onTabSelect = (tabs) => {
    localStorage.setItem("activetab", JSON.stringify(tabs));
    setSearchQuery('');
    setMenu(tabs);
    if (tabs.key === 'Conference') {
      setDataObj([]);
      fetchMeetingList();
      getActiveSurveys();
    } else if (tabs.key === 'Profile') {
      setProfileList([]);
      fetchProfileList();
    } else if (tabs.key === 'Attendee'){
    } else if (tabs.key === 'Reports'){
    } else if (tabs.key === 'KOL') {
      navigate('profiles');
    }  else if (tabs.key === 'Embedded Reports'){
        emebeddedReportsData();
      }  else if (tabs.key === 'Medicaid'){
        navigate('medicaid');
      }
  };

  const emebeddedReportsData = () => {
    ServiceUtils.getRequest("embedReport").then(
      (response) => {
        if (response?.data.status) {
          let data = response?.data;
          setEmbeddedReports(data);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };



  const onSelectCard = (data, startDate, endDate) => {
    localStorage.setItem("meetingListFilter", JSON.stringify({
      meetingFilter: [],
      attendeeFilter: [],
      objectiveFilter:[],
      kolFilter:[],
      followUpFilter:[],
      calenderDate: startDate ? new Date(startDate) : new Date(),
      calenderEndDate: endDate && new Date(endDate),
      view: 'day',
      conferenceId: null
    }));
    navigate(data);
  };


  const setBg = () => {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return "#" + randomColor;
  }
  const addNew = () => {
    if(selectedMenu.key === 'Profile'){
      navigate('profile/addProfile')
    }
    else if ( selectedMenu.key === 'Attendee'){
      navigate('profile/addAttendee')
    }
    else if(selectedMenu.key === 'Conference'){
      navigate('conference/addConference')
    }
  }

  const editConference = (id) => {
    navigate('conference/' + id);
  }

  const deleteConference = (id) => {
    let payload = {
      "type": "delete",
      "conference_id": id,
      // "conference_details": null,
      "user_id": userDetails?.user_id ? userDetails?.user_id : null
    }
    ServiceUtils.postRequest('addConference', payload).then(
        (response) => {
            if (response.status === 200 && response?.data.status) {
              fetchMeetingList();
            }
            else if(response.status === 401 ){
              navigate('/logout');
            }
        },
        (error) => {
            alertService.error('Error while fetching Objective.')
        }
    );
  }

  const items = [
    {
      label: <Space>Edit</Space>,
      key: '0',
      evtype:'edit'
    },
    {
      label: <Space>Delete</Space>,
      key: '1',
      evtype:'delete'
    }
  ];

  const onCli = ({ key }) => {
    message.info(`Click on item ${key}`);
  };
  const { useToken } = theme;
  const { token } = useToken();
  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  };
  const menuStyle = {
    boxShadow: 'none',
  };
  const getActiveSurveys = () => {
    const getSessionData = localStorage.getItem("arcutis-user");
    const session = getDecryptSession(getSessionData);
    if(!session?.role_access?.home?.surveys?.view) return;
    ServiceUtils.getRequest("listOfSurveys").then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          setActiveSurveyList(response?.data?.data);
        } 
      },
      (error) => {
        alertService.error("Error while fetching data.");
      }
    );
  };

  const setCurrentStateReport= (ind, value) =>{
    setCurrentReportIndex(ind)
    setExpanded(value);
  }

  // const handleHcpChangeData=async(value)=>{
  //   await setHcpData({...hcpData,npi_id:value})
  //   let payload = {npi_id:value}
  //   fetchSummaryData(payload);
  //   if(hcpData?.type === 'portfolio' && hcpData?.portfolios?.length > 0){
  //     let prescriptionPayload = {portfolio:hcpData?.portfolios,npi_id:value,type:hcpData?.type}
  //     fetchPrescriptionList(prescriptionPayload);
  //   }
  // }

  // const handleHcpTypeChange=(type)=>{
  //   setHcpData({...hcpData,type})
  //   if(type === 'products' && hcpData?.portfolios?.length > 0 ){
  //     let payload = {portfolio:hcpData?.portfolios,npi_id:hcpData?.npi_id,type:hcpData?.type}
  //     fetchProductsList(payload);
  // }
  //   let payload = {type,npi_id:hcpData?.npi_id}
  //   fetchPortfoliosList(payload);
  // }

  const navigateTo = (data) => {
    localStorage.setItem("surveysUserDetails", JSON.stringify({
      surveysUserDetails: userDetails,
    }));
    navigate(data);
  };

  const handleChange = (key, checked) => {
    setSwitchStates({
      current_year: key === 'current_year' ? !switchStates.current_year : false,
      all_conference: key === 'all_conference' ? !switchStates.all_conference : false,
    });
  };



  return (
    <>
      <div className="main-Content">
        <div style={{ maxHeight: "100%", overflow: "auto" }}>
          <div className="home-tabs ">
            {tabList &&
              tabList?.length > 1 &&
              tabList.map((tabs) => (
                <div
                  key={tabs?.key}
                  className={classNames("tabs-list", {
                    active: selectedMenu?.key === tabs.key,
                  })}
                  onClick={() => onTabSelect(tabs)}
                >
                  <Text>{tabs.label}</Text>
                </div>
              ))}
          </div>
          {selectedMenu.key === "Conference" &&
            userDetails?.role_access?.home?.surveys?.view && (
              <div style={{ padding: "0 20px" }}>
                <Title
                  style={{ padding: "0px 10px 10px 0px", margin: "0px" }}
                  className="home-side-header"
                  level={4}
                >
                  Surveys & FollowUp
                </Title>
                {/* minHeight:'16vh' */}
                <Card
                  className="surveyCard"
                  style={{ background: "white", padding: "8px" }}
                >
                  {/* justifyContent:"space-evenly" ,alignItems: 'flex-start',marginBottom: '5px' */}
                  <div style={cardStyle}>
                    <div style={{ padding: "2px" }}>
                      <Button
                        style={{ border: "1px solid #000000CC" }}
                        type="default"
                        onClick={() => navigateTo("surveyList")}
                      >
                        <span className="home-action-button">
                          <Image
                            src={surveyImage}
                            height={"16px"}
                            preview={false}
                            style={{ marginBottom: "2px" }}
                            alt="Survey"
                          />{" "}
                          Go To Surveys
                        </span>
                      </Button>
                    </div>
                    <div style={{ padding: "2px" }}>
                      <Button
                        style={{ border: "1px solid #000000CC" }}
                        type="default"
                        onClick={() => navigate("followUp")}
                      >
                        <span className="home-action-button">
                          <Image
                            src={surveyImage}
                            height={"16px"}
                            preview={false}
                            style={{ marginBottom: "2px" }}
                            alt="Survey"
                          />{" "}
                          Go To FollowUp
                        </span>
                      </Button>
                    </div>
                  </div>
                  {/* {activeSurveyList?.length > 0 ? 
              <Carousel dotPosition="bottom" autoplay autoplaySpeed={3000} adaptiveHeight>
                {activeSurveyList?.map((survey, index) => (
                  <Card styles={{body:{alignItems:'center'}}} className="internalCard" key={index} bordered={false} style={{ margin: '16px 0' ,width:'90%'}}>
                    <Row align="middle" wrap={false} gutter={16}>
                      <Col style={{alignItems: 'center',display: 'flex'}}>
                        <FileTextOutlined style={{ fontSize: '15px' ,paddingRight:'10px'}} />
                        <Text strong>{survey.surveyName}</Text>
                      </Col>
                      <Col>
                        <Text strong>{survey.surveytype}</Text>
                      </Col>
                      <Col>
                        <Text strong>{survey.description}</Text>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </Carousel>
              :
              <span className='noActiveSurveys'>No Active Surveys</span>} */}
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button style={{ border: '1px solid #000000CC', margin: '5px' }} type="default"
                    onClick={() => navigate('followUp')}>
                    <span className='home-action-button'>
                      <Image src={surveyImage} height={'16px'} preview={false} style={{ marginBottom: '2px' }} alt='Survey' /> Go To FollowUp
                    </span>
                  </Button>
                </div> */}
                </Card>
              </div>
            )}
          <div>
            {selectedMenu.key !== "KOL" &&
              selectedMenu.key !== "Attendee" &&
              selectedMenu.key !== "Surveys" && (
                <div className="meetingList">
                  <Row style={{ width: "100%" }}>
                    {selectedMenu.key === "KOL" &&
                    selectedMenu.key === "Attendee" ? (
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "100%" }}
                        md={{ flex: "100%" }}
                        lg={{ flex: "50%" }}
                        xl={{ flex: "50%" }}
                      >
                        <div
                          className={classNames("", {
                            "search-kol-mobile":
                              windowSize$ === "lg" ||
                              windowSize$ === "xl" ||
                              windowSize$ === "xxl",
                            "search-kol-mobile":
                              windowSize$ === "xs" ||
                              windowSize$ === "sm" ||
                              windowSize$ === "md",
                          })}
                        >
                          {/* <Search style={{ width: '100%' }} size="large" placeholder="Search" value={searchQuery} onChange={handleSearchInputChange} /> */}
                        </div>
                      </Col>
                    ) : (
                      <></>
                    )}
                    <Col
                      xs={{ flex: "100%" }}
                      sm={{ flex: "100%" }}
                      md={{ flex: "50%" }}
                      lg={{ flex: "50%" }}
                      xl={{ flex: "50%" }}
                    >
                      <div style={{ display: "flex", justifyContent: "start" }}>
                        {/* {selectedMenu.key === "Conference" &&
                          userDetails?.role_access?.home?.conferences?.view && (
                            <Title
                              className="home-side-header"
                              style={{ margin: "0px" }}
                              level={4}
                            >
                              {selectedMenu.label}
                            </Title>
                          )} */}
                      </div>
                    </Col>
                    {userDetails?.role_access?.home?.conferences?.edit && (
                      <Col
                        xs={{ flex: "100%" }}
                        sm={{ flex: "100%" }}
                        md={{ flex: "50%" }}
                        lg={{ flex: "50%" }}
                        xl={{ flex: "50%" }}
                      >
                        <div style={{ display: "flex", justifyContent: "end" }}>
                          {
                            ["Conference","Profile"].includes(selectedMenu.key) ? (
                              <Title
                            className="total-count"
                            style={{ marginRight: "18px" }}
                            level={4}
                          >
                            {" "}
                            Total{" "}
                            {selectedMenu.key === "Conference"
                              ? dataObj.length
                              : selectedMenu.key === "Profile"
                              ? filteredProfileList.length
                              : filteredAttendeeList.length}{" "}
                            {selectedMenu.key}
                          </Title>
                            ) : <></>
                          }
                          {selectedMenu.key === "Conference" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginTop: "8px",
                              }}
                            >
                              {switchData.map(({ key, label }) => (
                                <div key={key} style={{ margin: "5px" }}>
                                  <label>{label}: </label>
                                  <Switch
                                    checked={switchStates[key]}
                                    onChange={(checked) =>
                                      handleChange(key, checked)
                                    }
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                          {(selectedMenu.key === "Profile" ||
                            selectedMenu.key === "Attendee" ||
                            selectedMenu.key === "Conference") && (
                            <Button
                              style={{
                                background: "#000000",
                                marginTop: "14px",
                                marginLeft: "5px",
                              }}
                              type="primary"
                              onClick={() => addNew()}
                            >
                              <span className="home-action-button">+ Add</span>
                            </Button>
                          )}
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            {selectedMenu.key === "Conference" &&
              userDetails?.role_access?.home?.conferences?.view && (
                <div className="conference">
                  <div className="conference-height">
                    <Row type="flex">
                      {dataObj &&
                        dataObj.map((meet) => (
                          <>
                            <Col
                              style={{ padding: "0px 1% 0px 0px" }}
                              className="tile"
                              xs={{ flex: "100%" }}
                              sm={{ flex: "50%" }}
                              md={{ flex: "50%" }}
                              lg={{ flex: "25%" }}
                              xl={{ flex: "25%" }}
                            >
                              <div className="conference-card">
                                <Card
                                  title={meet?.conference_name}
                                  styles={{
                                    header: { backgroundColor: "#F3E8E8" },
                                  }}
                                  extra={
                                    userDetails?.role_access?.home?.conferences
                                      ?.edit && (
                                      <div style={{ display: "flex" }}>
                                        {/* <Tooltip title={"Edit " + meet?.conference_name}>
                                  <EditOutlined className="pointer" style={{marginRight:'20px'}} onClick={()=>{editConference(meet?.conference_id)}}/>
                                </Tooltip>
                                <Tooltip title={"Delete " + meet?.conference_name} onClick={()=>{deleteConference(meet?.conference_id)}}>
                                  <DeleteOutlined className="pointer"/>
                                </Tooltip> */}
                                        <Dropdown
                                          menu={{ items }}
                                          placement="bottom"
                                          // onClick: {editDeleteConference({meet?.conference_id})}

                                          dropdownRender={(menu) => (
                                            <div style={contentStyle}>
                                              {/* {React.cloneElement(menu, {
                                          style: menuStyle,
                                        })}
                                        <Divider
                                          style={{
                                            margin: 0,
                                          }}
                                        /> */}
                                              <Space
                                                className="pointer"
                                                style={{
                                                  padding: 8,
                                                }}
                                                onClick={() => {
                                                  editConference(
                                                    meet?.conference_id
                                                  );
                                                }}
                                              >
                                                {/* <Button type="primary">Click me!</Button> */}
                                                Edit
                                                {/* <EditOutlined/> */}
                                              </Space>
                                              <br />
                                              <Divider
                                                style={{
                                                  margin: 0,
                                                }}
                                              />
                                              <Space
                                                className="pointer"
                                                style={{
                                                  padding: 8,
                                                }}
                                                onClick={() => {
                                                  deleteConference(
                                                    meet?.conference_id
                                                  );
                                                }}
                                              >
                                                {/* <Button type="primary">Click me!</Button> */}
                                                Delete
                                                {/* <DeleteOutlined/> */}
                                              </Space>
                                            </div>
                                          )}
                                          trigger={["click"]}
                                        >
                                          <p
                                            onClick={(e) => {
                                              e.preventDefault();
                                            }}
                                          >
                                            <Space
                                              className="pointer"
                                              style={{
                                                marginTop: "12px",
                                                fontSize: "20px",
                                              }}
                                            >
                                              <Image
                                                src={moreImage}
                                                alt="More"
                                                height={"15px"}
                                                style={{
                                                  alignItems: "center",
                                                  display: "flex",
                                                }}
                                                preview={false}
                                              />
                                            </Space>
                                          </p>
                                        </Dropdown>
                                      </div>
                                    )
                                  }
                                  // style={{background: 'none'}}
                                >
                                  <Card
                                    className="pointer"
                                    style={{
                                      width: "100%",
                                      height: "170px",
                                      background: "none",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      background: "#EEF1F2B2",
                                    }}
                                    onClick={() =>
                                      onSelectCard(
                                        "meetingDetails" +
                                          "/" +
                                          meet?.conference_id,
                                        meet?.conference_start_date,
                                        meet?.conference_end_data
                                      )
                                    }
                                  >
                                    {/* <div className='conference-text' style={{padding:'12%'}}>
                                  <span>
                                    <Title level={3}>{meet.conference_name}</Title>
                                    <Title level={5}>{meet.conference_description}</Title>
                                  </span>
                                  <div> */}
                                    {/* <Avatar.Group>
                                      {meet && meet.attendee_Profile_URL && meet.attendee_Profile_URL.length > 0 && meet.attendee_Profile_URL.map(el =>
                                        <span>
                                          <Avatar src={el.URL} />
                                        </span>
                                      )}
                                    </Avatar.Group>
                                  </div> */}
                                    {/* </div> */}
                                    {/* <div className='conference-text'> */}
                                    {/* <Text className='conference-team'>{meet.agenda}</Text> */}
                                    {/* <Text className='conference-team'>{meet.attendee}</Text>
                                </div>
                                <div className='conference-text'>
                                  <Text className='conference-text-color conference-time'>{meet.meeting_start_time}</Text>
                                  <Text className='hrs'>{meet.hours}</Text>
                                  <Text className='conference-text-color conference-time'>{meet.meeting_end_time}</Text> */}
                                    {/* </div> */}
                                    {/* <p>{meet?.conference_name}</p> */}
                                    <Image
                                      style={{
                                        width: "100%",
                                        height: "150px",
                                        verticalAlign: "middle",
                                      }}
                                      preview={false}
                                      src={meet?.conference_image}
                                    />
                                  </Card>
                                </Card>
                              </div>
                            </Col>
                          </>
                        ))}
                    </Row>
                  </div>
                </div>
              )}
            {selectedMenu.key === "Profile" && (
              <div className="conference">
                <div className="conference-height">
                  <Row>
                    {filteredProfileList &&
                      filteredProfileList.map((el) => (
                        <Col
                          className="tile"
                          style={{ padding: "0px 1% 0px 0px" }}
                          xs={{ flex: "100%" }}
                          sm={{ flex: "50%" }}
                          md={{ flex: "50%" }}
                          lg={{ flex: "25%" }}
                          xl={{ flex: "25%" }}
                        >
                          <div className="attendee-body">
                            <Card
                              className="pointer"
                              style={{
                                width: "100%",
                                height: "fit-content",
                                borderRadius: "4px",
                              }}
                              onClick={() =>
                                onSelectCard(
                                  "profileDetails" + "/" + el.profile_id
                                )
                              }
                            >
                              <Space size={16}>
                                <Space wrap size={16}>
                                  <Avatar
                                    style={{
                                      backgroundColor: setBg(),
                                      verticalAlign: "middle",
                                    }}
                                    size={55}
                                  >
                                    <span className="avatar-Text">
                                      {el.full_name.split(" ")[0][0]}
                                      {el.full_name.split(" ")[1][0]}
                                    </span>
                                  </Avatar>
                                </Space>
                                <div>
                                  <Title level={4} style={{ color: "#3D3D3D" }}>
                                    {el.full_name}
                                  </Title>
                                  <Text className="text-ellipsis-one-line">
                                    {el.venue}
                                  </Text>
                                </div>
                              </Space>
                              <div
                                style={{ marginTop: "10px" }}
                                className="display-flex justify-content"
                              >
                                <div style={{ display: "grid" }}>
                                  <Text style={{ color: "#B9B9B9" }}>
                                    Professional type
                                  </Text>
                                  <Text className="text-center">
                                    {el.degree}
                                  </Text>
                                </div>
                                <div style={{ display: "grid" }}>
                                  <Text style={{ color: "#B9B9B9" }}>
                                    Title
                                  </Text>
                                  <Text className="text-center">
                                    {el.area_of_expertise}
                                  </Text>
                                </div>
                              </div>
                              <Space size={10}>
                                <Space wrap size={10}>
                                  <svg
                                    style={{ marginTop: "5px" }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 20 20"
                                  >
                                    <g id="email_black_24dp" opacity="0.5">
                                      <path
                                        id="Path_11416"
                                        data-name="Path 11416"
                                        d="M0,0H20V20H0Z"
                                        fill="none"
                                      />
                                      <path
                                        id="Path_11417"
                                        data-name="Path 11417"
                                        d="M17,4H3.667A1.664,1.664,0,0,0,2.008,5.667L2,15.667a1.672,1.672,0,0,0,1.667,1.667H17a1.672,1.672,0,0,0,1.667-1.667v-10A1.672,1.672,0,0,0,17,4Zm0,3.333L10.333,11.5,3.667,7.333V5.667l6.667,4.167L17,5.667Z"
                                        transform="translate(-0.333 -0.667)"
                                      />
                                    </g>
                                  </svg>
                                </Space>
                                <Text style={{ color: "#2973FE" }}>
                                  {el.email}
                                </Text>
                              </Space>
                              <div>
                                <Space size={10}>
                                  <Space wrap size={10}>
                                    <svg
                                      style={{ marginTop: "5px" }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 18 18"
                                    >
                                      <g id="phone--filled" opacity="0.5">
                                        <path
                                          id="Path_11415"
                                          data-name="Path 11415"
                                          d="M12.742,13.395,14,12.135a1.232,1.232,0,0,1,1.316-.27l1.536.613a1.226,1.226,0,0,1,.765,1.125v2.812a1.221,1.221,0,0,1-1.283,1.209C5.576,16.956,3.4,7.843,2.994,4.356A1.221,1.221,0,0,1,4.215,3H6.932a1.215,1.215,0,0,1,1.125.765L8.67,5.3a1.215,1.215,0,0,1-.264,1.316l-1.26,1.26S7.871,12.787,12.742,13.395Z"
                                          transform="translate(-1.307 -1.312)"
                                        />
                                        <rect
                                          id="_Transparent_Rectangle_"
                                          data-name="&lt;Transparent Rectangle&gt;"
                                          width="18"
                                          height="18"
                                          fill="none"
                                        />
                                      </g>
                                    </svg>
                                  </Space>
                                  <Text>{el.phone_number}</Text>
                                </Space>
                              </div>
                            </Card>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </div>
              </div>
            )}
            {selectedMenu.key === "Attendee" && (
              <ArcutisAttendee userDetails={userDetails} />
            )}
            {selectedMenu.key === "Reports" && workspace?.workspace_list.length && (
              <>
                <Reports {...workspace}/>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}